export const c_form_control_m_icon_sprite__select_BackgroundPositionX = {
  "name": "--pf-c-form-control--m-icon-sprite__select--BackgroundPositionX",
  "value": "calc(100% - 1rem + 7px)",
  "var": "var(--pf-c-form-control--m-icon-sprite__select--BackgroundPositionX)"
};
export default c_form_control_m_icon_sprite__select_BackgroundPositionX;